var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHelicopter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1551,
    stopColor: "#9b489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#84438f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#5e3b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.756,
    x2: 111.076,
    xlinkHref: "#lg1",
    y1: 95.611,
    y2: 175.003
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.086,
    x2: 297.407,
    xlinkHref: "#lg1",
    y1: 95.611,
    y2: 175.003
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.501,
    x2: 181.501,
    y1: 118.194,
    y2: 155.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.501,
    x2: 181.501,
    xlinkHref: "#lg2",
    y1: 141.623,
    y2: 167.398
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.201,
    x2: 496.916,
    xlinkHref: "#lg2",
    y1: 138.472,
    y2: 181.187
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.404,
    x2: 481.516,
    xlinkHref: "#lg2",
    y1: 246.909,
    y2: 204.454
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.707,
    x2: 383.707,
    xlinkHref: "#lg2",
    y1: 160.288,
    y2: 276.331
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.792,
    x2: 418.821,
    xlinkHref: "#lg3",
    y1: 187.165,
    y2: 206.839
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.693,
    x2: 362.737,
    xlinkHref: "#lg4",
    y1: 268.826,
    y2: 129.042
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.979,
    x2: 238.592,
    xlinkHref: "#lg4",
    y1: 264.761,
    y2: 209.189
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.237,
    x2: 199.782,
    xlinkHref: "#lg5",
    y1: 265.683,
    y2: 400.228
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.004,
    x2: 78.09,
    xlinkHref: "#lg5",
    y1: 318.175,
    y2: 346.261
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-1 0 0 1 181.144 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -19.882,
    x2: 8.204,
    xlinkHref: "#lg5",
    y1: 318.175,
    y2: 346.261
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.657,
    x2: 203.71,
    xlinkHref: "#lg2",
    y1: 170.452,
    y2: 406.545
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.018,
    x2: 147.373,
    xlinkHref: "#lg3",
    y1: 293.757,
    y2: 370.384
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.546,
    x2: 158.812,
    xlinkHref: "#lg2",
    y1: 179.369,
    y2: 347.966
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.5,
    x2: 132.915,
    xlinkHref: "#lg5",
    y1: 215.297,
    y2: 285.888
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.005,
    x2: 233.964,
    xlinkHref: "#lg5",
    y1: 210.836,
    y2: 278.601
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.752,
    x2: 180.066,
    xlinkHref: "#lg4",
    y1: 293.422,
    y2: 182.624
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.23,
    x2: 159.23,
    xlinkHref: "#lg2",
    y1: 283.137,
    y2: 264.95
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.761,
    x2: 231.01,
    xlinkHref: "#lg1",
    y1: 111.878,
    y2: 155.876
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.596,
    x2: 477.744,
    xlinkHref: "#lg4",
    y1: 226.347,
    y2: 201.495
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.707 .707 -.707 .707 280.026 -281.474)",
    gradientUnits: "userSpaceOnUse",
    x1: 454.008,
    x2: 498.19,
    xlinkHref: "#lg1",
    y1: 185.344,
    y2: 213.648
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 958.456 -2.296)",
    gradientUnits: "userSpaceOnUse",
    x1: 458.482,
    x2: 502.664,
    xlinkHref: "#lg1",
    y1: 181.23,
    y2: 209.534
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.367,
    x2: 485.143,
    xlinkHref: "#lg2",
    y1: 198.118,
    y2: 208.894
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.46,
    x2: 209.004,
    xlinkHref: "#lg1",
    y1: 285.551,
    y2: 420.096
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.227,
    x2: 87.312,
    xlinkHref: "#lg1",
    y1: 338.043,
    y2: 366.128
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-1 0 0 1 181.144 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -29.104,
    x2: -1.018,
    xlinkHref: "#lg1",
    y1: 338.043,
    y2: 366.128
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m181.806 138.689h-173.15c-3.64 0-6.59-2.95-6.59-6.59 0-3.64 2.95-6.59 6.59-6.59h173.15c3.64 0 6.59 2.951 6.59 6.59 0 3.64-2.95 6.59-6.59 6.59z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m368.137 138.689h-173.15c-3.639 0-6.59-2.95-6.59-6.59 0-3.64 2.951-6.59 6.59-6.59h173.15c3.639 0 6.59 2.951 6.59 6.59 0 3.64-2.951 6.59-6.59 6.59z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m199.314 153.186h-35.625v-15.194c0-7.622 6.178-13.8 13.8-13.8h8.024c7.622 0 13.8 6.179 13.8 13.8v15.194z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m213.351 165.785h-63.699v-5.76c0-7.875 6.384-14.26 14.26-14.26h35.18c7.875 0 14.26 6.384 14.26 14.26v5.76z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m491.061 186.041h-36.528l4.162-22.17c2.923-15.573 12.201-29.225 25.605-37.675 2.936-1.851 6.762.259 6.762 3.73v56.115z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m491.061 178.937h-36.528l4.162 22.17c2.923 15.573 12.201 29.225 25.605 37.675 2.936 1.851 6.762-.259 6.762-3.73v-56.115z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m488.052 222.832h-90.437c-34.111 0-67.713 8.268-97.93 24.095l-42.272 22.142v-90.133h230.639c12.121 0 21.948 9.826 21.948 21.948 0 12.122-9.826 21.948-21.948 21.948z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m399.895 178.937h19.674v43.896h-19.674z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m488.052 199.255h-90.437c-34.111 0-67.713 8.268-97.93 24.095l-42.272 22.142v23.577l42.272-22.142c30.216-15.827 63.819-24.095 97.93-24.095h90.437c12.121 0 21.948-9.826 21.948-21.948 0-4.343-1.278-8.381-3.455-11.788-3.898 6.102-10.715 10.159-18.493 10.159z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m262.096 178.937h-4.683v90.133l42.272-22.142c6.801-3.562 13.782-6.72 20.893-9.509z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m191.579 365.94h-119.264c-26.58 0-51.582-9.929-70.401-27.959-2.477-2.373-2.562-6.306-.188-8.784 2.374-2.477 6.307-2.562 8.785-.187 16.255 15.573 38.781 24.505 61.804 24.505h119.264c23.361 0 45.31-8.703 61.804-24.505l1.126-1.078c2.478-2.374 6.411-2.289 8.784.189 2.374 2.479 2.289 6.411-.19 8.785l-1.124 1.077c-18.818 18.028-43.82 27.957-70.4 27.957z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m57.045 364.731c-3.431 0-6.213-2.782-6.213-6.213v-15.88c0-15.09 5.533-29.6 15.58-40.858 2.286-2.56 6.214-2.783 8.772-.499 2.56 2.284 2.783 6.212.499 8.772-8.013 8.978-12.426 20.55-12.426 32.584v15.88c.001 3.433-2.781 6.214-6.212 6.214z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m193.984 364.731c-3.431 0-6.213-2.782-6.213-6.213v-15.88c0-12.034-4.412-23.606-12.425-32.584-2.285-2.56-2.061-6.488.498-8.772 2.56-2.285 6.487-2.062 8.772.499 10.047 11.258 15.58 25.768 15.58 40.858v15.88c.001 3.431-2.781 6.212-6.212 6.212z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m155.419 157.147c-50.16 0-92.216 34.686-103.497 81.381-2.631 10.888-10.911 19.515-21.755 22.32-13.267 3.432-22.534 15.402-22.534 29.106 0 21.97 17.811 39.781 39.781 39.781h157.368c47.659 0 86.294-38.635 86.294-86.294 0-47.659-38.635-86.294-86.294-86.294z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m232.53 309.321h-219.863c6.801 12.176 19.809 20.413 34.746 20.413h157.368c23.445 0 44.692-9.359 60.238-24.536-10.38 2.691-21.266 4.123-32.489 4.123z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m59.727 261.174v48.136c0 5.558 4.505 10.063 10.063 10.063h108.544c5.558 0 10.063-4.505 10.063-10.063v-107.024c0-17.398-14.104-31.501-31.501-31.501h-6.779c-24.506 0-47.961 9.95-64.992 27.57-16.292 16.854-25.398 39.378-25.398 62.819z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m166.31 255.918h-87.103c-6.051 0-10.627-5.408-9.715-11.391 5.488-36.012 36.589-63.603 74.134-63.603h12.48c11.066 0 20.037 8.971 20.037 20.037v45.123c.001 5.431-4.402 9.834-9.833 9.834z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m227.359 180.924h-6.256c-12.153 0-22.005 9.852-22.005 22.005v30.984c0 12.153 9.852 22.005 22.005 22.005h6.256c12.153 0 22.005-9.852 22.005-22.005v-30.984c0-12.153-9.852-22.005-22.005-22.005z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m224.906 274.773h-213.132c-2.634 4.495-4.141 9.693-4.141 15.181 0 21.97 17.811 39.781 39.781 39.781h157.368c43.759 0 79.885-32.578 85.509-74.799-18.699 12.527-41.187 19.837-65.385 19.837z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m151.639 265.189h15.183c3.336 0 6.04 2.704 6.04 6.04 0 3.336-2.704 6.04-6.04 6.04h-15.183c-3.336 0-6.04-2.704-6.04-6.04 0-3.336 2.704-6.04 6.04-6.04z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m261.724 138.689h-78.991c-3.64 0-6.59-2.95-6.59-6.59 0-3.64 2.951-6.59 6.59-6.59h78.991c3.64 0 6.59 2.951 6.59 6.59 0 3.64-2.95 6.59-6.59 6.59z",
    fill: "url(#SVGID_21_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m505.205 214.556-21.037-21.037c-1.872-2.138-4.615-3.494-7.68-3.494-5.642 0-10.215 4.574-10.215 10.215 0 3.065 1.357 5.807 3.494 7.68l14.913 14.913h3.372c6.948-.001 13.131-3.238 17.153-8.277z",
    fill: "url(#SVGID_22_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m445.493 231.234c-2.527-2.527-2.527-6.624 0-9.151l52.838-52.838c2.527-2.527 6.624-2.527 9.151 0 2.527 2.527 2.527 6.624 0 9.151l-52.838 52.838c-2.526 2.527-6.624 2.527-9.151 0z",
    fill: "url(#SVGID_23_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m445.493 169.245c2.527-2.527 6.624-2.527 9.151 0l52.838 52.838c2.527 2.527 2.527 6.624 0 9.151-2.527 2.527-6.624 2.527-9.151 0l-52.838-52.838c-2.527-2.527-2.527-6.624 0-9.151z",
    fill: "url(#SVGID_24_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 476.488,
    cy: 200.239,
    fill: "url(#SVGID_25_)",
    r: 10.215
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m200.802 385.808h-119.264c-26.58 0-51.582-9.929-70.4-27.959-2.477-2.373-2.562-6.306-.188-8.784 2.374-2.477 6.306-2.561 8.784-.187 16.255 15.573 38.782 24.505 61.804 24.505h119.264c23.361 0 45.31-8.703 61.804-24.505l1.126-1.078c2.478-2.374 6.411-2.289 8.784.189 2.374 2.478 2.289 6.411-.19 8.784l-1.125 1.077c-18.818 18.028-43.82 27.958-70.399 27.958z",
    fill: "url(#SVGID_26_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m66.268 384.599c-3.431 0-6.213-2.782-6.213-6.213v-15.88c0-15.09 5.533-29.6 15.581-40.858 2.286-2.56 6.213-2.783 8.772-.499 2.56 2.284 2.783 6.212.498 8.772-8.013 8.978-12.425 20.55-12.425 32.584v15.88c0 3.432-2.782 6.214-6.213 6.214z",
    fill: "url(#SVGID_27_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m203.206 384.599c-3.431 0-6.213-2.782-6.213-6.213v-15.88c0-12.034-4.413-23.606-12.425-32.584-2.285-2.56-2.061-6.488.499-8.772 2.559-2.285 6.487-2.062 8.772.499 10.047 11.258 15.58 25.768 15.58 40.858v15.88c0 3.43-2.782 6.212-6.213 6.212z",
    fill: "url(#SVGID_28_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelicopter);
export default __webpack_public_path__ + "static/media/icon-helicopter.3f150bf425efa2f53843e973cc49e3ac.svg";
export { ForwardRef as ReactComponent };